<template>
  <div class="comp">
    <div class="compContent">
      <div class="title">
        <div class="titleL" v-if="yaofangParams.tabIndex === 0">
          病例录药详情
        </div>
        <div class="titleL" v-if="yaofangParams.tabIndex === 1">
          疫苗驱虫录药详情
        </div>
        <div class="titleL" v-if="yaofangParams.tabIndex === 2">
          医疗服务录药详情
        </div>
        <div class="titleR">
          <el-button type="warning" plain size="small" @click="back"
            >返回</el-button
          >
        </div>
      </div>
      <div class="content">
        <div class="msg">
          <div class="msgItem">
            <div class="label">顾客名称:</div>
            <div class="value">
              {{ detail.memberName }}
            </div>
          </div>
          <div class="msgItem">
            <div class="label">宠物昵称:</div>
            <div class="value">
              {{ detail.petName }} ({{ detail.typeName }})
            </div>
          </div>
          <div class="msgItem">
            <div class="label">添加人:</div>
            <div class="value">
              {{ detail.createUserName }}
            </div>
          </div>
          <div class="msgItem">
            <div class="label">套餐名称:</div>
            <div class="value">
              <span v-if="yaofangParams.tabIndex === 0">--</span>
              <span v-if="yaofangParams.tabIndex === 1">{{
                detail.servicePackageName
              }}</span>
              <span v-if="yaofangParams.tabIndex === 2">{{
                detail.medicalServiceName
              }}</span>
            </div>
          </div>
          <div class="msgItem">
            <div class="label">实施计划:</div>
            <div class="value">
              <span v-if="yaofangParams.tabIndex === 0">--</span>
              <span v-if="yaofangParams.tabIndex === 1">{{
                detail.planName
              }}</span>
              <span v-if="yaofangParams.tabIndex === 2">--</span>
            </div>
          </div>
          <div class="msgItem">
            <div class="label">日期:</div>
            <div class="value">
              {{ $public.FTime(detail.createTime) }}
            </div>
          </div>
        </div>
        <div class="relation">
          <div class="relationTitLine">
            <div style="line-height: 40px">
              <span>商品列表</span>
            </div>
            <div></div>
          </div>
          <el-table
            :data="tableData"
            style="width: 100%"
            default-expand-all
            row-key="tableKey"
            :tree-props="{ children: 'goodsList', hasChildren: 'hasChildren' }"
          >
            <el-table-column label="名称" min-width="250">
              <template slot-scope="props">
                <svg
                  v-if="props.row.goodsList && props.row.goodsType === 1"
                  t="1597312802518"
                  style="vertical-align: middle; padding-right: 10px"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="8321"
                  width="32"
                  height="32"
                >
                  <path
                    d="M171 674.4h36.1V349.9H171v324.5z m90-324.5h-18.1V602H261V349.9z m35.9 252h18v-252h-18v252z m108.1-252h-54V602h54V349.9z m53.6 252h18v-252h-18v252z m71.8 0h36.1v-252h-36.1v252z m71.9 0h18v-252h-18v252z m161.8-252H728V602h36.1V349.9z m53.8 324.5H854V349.9h-36.1v324.5z m-143.7-72.5h18v-252h-18v252z m234-358.7h-791c-29.7 0-53.9 24.2-53.9 53.9v430c0 29.7 24.2 53.9 53.9 53.9h790.9c29.7 0 53.9-24.2 53.9-53.9v-430c0.1-29.7-24.1-53.9-53.8-53.9z m17.9 484c0 9.9-8.1 18-18 18H117.2c-9.9 0-18-8.1-18-18v-430c0-9.9 8.1-18 18-18h790.9c9.9 0 18 8.1 18 18v430z m-611-53.4H351v-36.5h-35.9v36.5z m413.3 0h35.9v-36.5h-35.9v36.5z m-341.5 0h35.9v-36.5h-35.9v36.5z m251.6 0h35.9v-36.5h-35.9v36.5z m-161.7 0h35.9v-36.5h-35.9v36.5z m89.8 0h35.9v-36.5h-35.9v36.5z m-323.4 0h35.9v-36.5h-35.9v36.5z"
                    p-id="8322"
                  ></path>
                </svg>
                <span
                  v-if="props.row.goodsList"
                  style="vertical-align: middle"
                  :style="{
                    color: props.row.isOut === false ? 'red' : '#606266',
                  }"
                  >{{ props.row.goodsName }}</span
                >
              </template>
            </el-table-column>
            <el-table-column label="条码" prop="customCode" min-width="110">
            </el-table-column>
            <el-table-column label="数量" min-width="90">
              <template slot-scope="props">
                <div v-if="props.row.goodsList">{{ props.row.num }}</div>
              </template>
            </el-table-column>
            <el-table-column label="用量" min-width="100">
              <template slot-scope="props">
                <div v-if="props.row.goodsList">
                  {{ props.row.goodsDosage }}
                  <span>{{ props.row.outUnit }}</span>
                </div>
                <div v-if="!props.row.goodsList">
                  <el-input disabled v-model="props.row.goodsDosage">
                    <template slot="append" style="padding: 0">{{
                      props.row.outUnit
                    }}</template>
                  </el-input>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="最大用量" min-width="100">
              <template slot-scope="props">
                <div v-if="!props.row.goodsList">{{ props.row.onlyTimes }}</div>
              </template>
            </el-table-column>
            <el-table-column label="规格" min-width="100">
              <template slot-scope="props">
                <div v-if="props.row.goodsList">{{ props.row.skuValue }}</div>
              </template>
            </el-table-column>
            <el-table-column label="价格" min-width="100">
              <template slot-scope="props">
                <div v-if="props.row.goodsList">{{ props.row.price }}</div>
              </template>
            </el-table-column>
            <el-table-column label="单位" min-width="80">
              <template slot-scope="props">
                <div v-if="props.row.goodsList">{{ props.row.unit }}</div>
              </template>
            </el-table-column>
            <el-table-column label="总金额" min-width="100">
              <template slot-scope="props">
                <div v-if="props.row.allowWholesale === 0">
                  <div v-if="props.row.goodsList">
                    {{ $public.cheng(props.row.goodsDosage, props.row.price) }}
                  </div>
                </div>
                <div v-else>
                  <div v-if="props.row.goodsList">
                    {{ $public.cheng(props.row.num, props.row.price) }}
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div style="padding: 20px 0">
            <svg
              t="1597312802518"
              style="vertical-align: middle; padding-left: 12px"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="8321"
              width="32"
              height="32"
            >
              <path
                d="M171 674.4h36.1V349.9H171v324.5z m90-324.5h-18.1V602H261V349.9z m35.9 252h18v-252h-18v252z m108.1-252h-54V602h54V349.9z m53.6 252h18v-252h-18v252z m71.8 0h36.1v-252h-36.1v252z m71.9 0h18v-252h-18v252z m161.8-252H728V602h36.1V349.9z m53.8 324.5H854V349.9h-36.1v324.5z m-143.7-72.5h18v-252h-18v252z m234-358.7h-791c-29.7 0-53.9 24.2-53.9 53.9v430c0 29.7 24.2 53.9 53.9 53.9h790.9c29.7 0 53.9-24.2 53.9-53.9v-430c0.1-29.7-24.1-53.9-53.8-53.9z m17.9 484c0 9.9-8.1 18-18 18H117.2c-9.9 0-18-8.1-18-18v-430c0-9.9 8.1-18 18-18h790.9c9.9 0 18 8.1 18 18v430z m-611-53.4H351v-36.5h-35.9v36.5z m413.3 0h35.9v-36.5h-35.9v36.5z m-341.5 0h35.9v-36.5h-35.9v36.5z m251.6 0h35.9v-36.5h-35.9v36.5z m-161.7 0h35.9v-36.5h-35.9v36.5z m89.8 0h35.9v-36.5h-35.9v36.5z m-323.4 0h35.9v-36.5h-35.9v36.5z"
                p-id="8322"
              ></path>
            </svg>
            <span style="font-size: 14px">表示：该项需要录入条码</span>
          </div>
          <div class="relationTitLine">
            <div style="line-height: 40px">服务列表</div>
            <div></div>
          </div>
          <el-table
            :data="serviceTableData"
            style="width: 100%"
            default-expand-all
          >
            <el-table-column type="expand">
              <template slot-scope="scope">
                <div class="goodsLine">
                  <div class="goodsLineTit">
                    <div>耗材列表</div>
                    <div>
                      <div v-if="scope.row.planLock == false">
                        <el-button
                          v-if="
                            scope.row.planStatus != 2 &&
                            detail.serviceStatus != 2
                          "
                          type="text"
                          icon="el-icon-plus"
                          size="small"
                          @click="addGoods(scope.$index)"
                          >添加药品</el-button
                        >
                      </div>
                    </div>
                  </div>
                  <el-table
                    :data="scope.row.goodsList"
                    style="width: 100%; margin-bottom: 20px"
                    size="mini"
                    row-key="tableKey"
                    :empty-text="'无耗材'"
                  >
                    <el-table-column label="耗材名称" min-width="150">
                      <template slot-scope="props">
                        {{ props.row.name }}
                      </template>
                    </el-table-column>
                    <el-table-column label="包装单位" min-width="100">
                      <template slot-scope="props">
                        {{ props.row.use_unit }}
                      </template>
                    </el-table-column>
                    <el-table-column label="使用数量" min-width="150">
                      <template slot-scope="props">
                        <el-input
                          v-model="props.row.count"
                          disabled
                          style="width: 150px"
                        >
                          <template slot="append" style="padding: 0">{{
                            props.row.use_unit
                          }}</template>
                        </el-input>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" width="150">
                      <!-- <template slot-scope="props">
												<el-button v-if="props.row.is_must===true" style="width:60px" size="mini" type='danger' @click="delConsumable(scope.$index,props.$index)">删除</el-button>
											</template> -->
                    </el-table-column>
                  </el-table>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="服务名称">
              <template slot-scope="props">
                <span style="vertical-align: middle">{{
                  props.row.goodsName
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="规格" width="200">
              <template slot-scope="props">
                <div>{{ props.row.skuValue }}</div>
              </template>
            </el-table-column>
            <el-table-column label="价格" width="150">
              <template slot-scope="props">
                <div>{{ props.row.price }}</div>
              </template>
            </el-table-column>
            <el-table-column label="数量" width="120">
              <template slot-scope="props">
                <div>{{ props.row.num }}</div>
              </template>
            </el-table-column>
            <el-table-column label="总金额" width="120">
              <template slot-scope="props">
                {{ $public.cheng(props.row.num, props.row.price) }}
              </template>
            </el-table-column>
            <el-table-column label="单位" width="120">
              <template slot-scope="props">
                <div>{{ props.row.unit }}</div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <div class="settlement">
      <div class="settlementL">
        <span>共计：</span
        ><span style="font-size: 16px; margin-right: 40px"
          >{{ total.count }}件</span
        >
      </div>
      <div class="settlementR">
        <span>总计：</span
        ><span style="font-size: 16px; margin-right: 20px"
          >￥{{ total.money }}</span
        >
      </div>
    </div>
  </div>
</template>
<script>
import del from "../../../../util/del.js";
export default {
  data() {
    return {
      detail: {},
      tableData: [],
      total: {
        count: 0,
        money: 0,
      },
      scanningCodeInput: "",
      o: null,
      curRow: "",
      // 服务
      serviceTableData: [],
    };
  },
  computed: {
    yaofangParams() {
      return this.$store.state.yiliaoxin.yaofangParams;
    },
  },
  mounted() {
    this.o = new del(); // 仅仅使用获取条码接口
    this.getDetail();
  },
  methods: {
    back() {
      this.$store.commit("yiliaoxin/remove_router");
      if (this.$store.state.yiliaoxin.router.length === 0) {
        this.yaofangParams.type = "list";
        this.$store.commit("yiliaoxin/set_yaofangParams", this.yaofangParams);
        this.$store.commit("yiliaoxin/set_curBusiness", "药房");
      }
    },
    getDetail() {
      this.tableData = [];
      this.total.count = 0;
      this.total.money = 0;
      if (this.yaofangParams.tabIndex === 0) {
        this.$http
          .get("/api/Case/Detail", {
            caseNumber: this.yaofangParams.curRow.caseNumber,
          })
          .then((res) => {
            if (res.code == 0) {
              this.detail = res.data;
              let inspectItem = [];
              for (let i = 0; i < res.data.inspectItem.length; i++) {
                if (res.data.inspectItem[i].goodsType !== 4) {
                  inspectItem.push(res.data.inspectItem[i]);
                }
              }
              let tableData = res.data.recipelItem.concat(inspectItem);
              let table2 = this.filterList(tableData);
              this.o.init(table2);
              this.tableData = this.o.arr;
              for (let i = 0; i < this.tableData.length; i++) {
                this.total.count = this.total.count + this.tableData[i].num;
                if (this.tableData[i].allowWholesale === 0) {
                  this.total.money = this.$public.jia(
                    this.total.money,
                    this.$public.cheng(
                      this.tableData[i].goodsDosage,
                      this.tableData[i].price
                    )
                  );
                } else {
                  this.total.money = this.$public.jia(
                    this.total.money,
                    this.$public.cheng(
                      this.tableData[i].num,
                      this.tableData[i].price
                    )
                  );
                }
              }
              // 服务
              let serviceTableData = [];
              let serviceInspectItem = [];
              for (let i = 0; i < res.data.inspectItem.length; i++) {
                if (res.data.inspectItem[i].goodsType === 4) {
                  serviceInspectItem.push(res.data.inspectItem[i]);
                }
              }
              serviceTableData = serviceInspectItem
                .concat(res.data.operationItem)
                .concat(res.data.handleItem);
              this.getConsumableList(serviceTableData);
            }
          });
      } else if (this.yaofangParams.tabIndex === 1) {
        this.$http
          .get("/api/MedicalPackage/Plan/Detail", {
            planId: this.yaofangParams.curRow.planId,
          })
          .then((res) => {
            if (res.code == 0) {
              this.detail = res.data;
              let tableData = res.data.planGoods || [];
              let table = [];
              for (let i = 0; i < tableData.length; i++) {
                if (tableData[i].goodsType === 1) {
                  tableData[i].goodsList = tableData[i].goodsItemRecords || [];
                  if (tableData[i].replaceType !== 1) {
                    table.push(tableData[i]);
                  }
                }
              }
              let table2 = this.filterList(table);
              this.o.init(table2);
              this.tableData = this.o.arr;
              for (let i = 0; i < this.tableData.length; i++) {
                this.total.count = this.total.count + this.tableData[i].num;
                if (this.tableData[i].allowWholesale === 0) {
                  this.total.money = this.$public.jia(
                    this.total.money,
                    this.$public.cheng(
                      this.tableData[i].goodsDosage,
                      this.tableData[i].price
                    )
                  );
                } else {
                  this.total.money = this.$public.jia(
                    this.total.money,
                    this.$public.cheng(
                      this.tableData[i].num,
                      this.tableData[i].price
                    )
                  );
                }
              }
            }
          });
      } else if (this.yaofangParams.tabIndex === 2) {
        this.$http
          .get("/api/MedicalService/Detail", {
            id: this.yaofangParams.curRow.id,
          })
          .then((res) => {
            if (res.code == 0) {
              this.detail = res.data;
              let tableData = res.data.serviceGoods || [];
              let table = [];
              for (let i = 0; i < tableData.length; i++) {
                if (tableData[i].goodsType === 1) {
                  tableData[i].goodsList = tableData[i].goodsItemRecords || [];
                  if (tableData[i].replaceType !== 1) {
                    table.push(tableData[i]);
                  }
                }
              }
              let table2 = this.filterList(table);
              this.o.init(table2);
              this.tableData = this.o.arr;
              for (let i = 0; i < this.tableData.length; i++) {
                this.total.count = this.total.count + this.tableData[i].num;
                if (this.tableData[i].allowWholesale === 0) {
                  this.total.money = this.$public.jia(
                    this.total.money,
                    this.$public.cheng(
                      this.tableData[i].goodsDosage,
                      this.tableData[i].price
                    )
                  );
                } else {
                  this.total.money = this.$public.jia(
                    this.total.money,
                    this.$public.cheng(
                      this.tableData[i].num,
                      this.tableData[i].price
                    )
                  );
                }
              }
            }
          });
      }
    },
    // 重组tableData
    filterList(tableData) {
      let table = [];
      for (let i = 0; i < tableData.length; i++) {
        let goods = tableData[i];
        if (goods.goodsList == null) {
          goods.goodsList = [];
        }
        if (goods.isPay === true) {
          // 只处理已支付的
          let one = {
            goodsItemsId: goods.itemsId, // 该接口需要
            checkGoods: "",
            goodsId: goods.goodsId,
            goodsName: goods.goodsName,
            goodsType: goods.goodsType,
            skus: goods.skus || goods.goodsId, // 规格 skus
            skuValue: goods.skuValue || "", // 规格 skuValue
            unit: goods.unit,
            outUnit: goods.outUnit,
            allowWholesale: goods.allowWholesale,
            originalPrice: goods.originalPrice,
            price: goods.price,
            num: goods.num,
            isPay: goods.isPay,
            activityId: "",
            activityName: "",
            totalMoney: "",
            goodsUsage: goods.goodsUsage,
            goodsDosage: goods.goodsDosage,
            goodsList: [],
            remark: goods.remark,
            extendContent: goods.extendContent
              ? JSON.parse(goods.extendContent)
              : "",
            isOut: goods.isOut || false,
          };
          one.tableKey = "tableKey_goods_one" + Math.random();
          one.checkGoods = JSON.parse(JSON.stringify(one));
          table.push(one);
        }
      }
      return table;
    },
  },
};
</script>
<style scoped lang="scss">
.comp {
  position: relative;
  height: 100%;
  padding-bottom: 68px;
  box-sizing: border-box;
  .compContent {
    height: 100%;
    background-color: #fff;
    border-radius: 12px;
    overflow: auto;
    .title {
      display: flex;
      height: 47px;
      line-height: 27px;
      border-bottom: 1px solid #f2f2f2;
      padding: 10px 18px;
      box-sizing: border-box;
      .titleL {
        width: 50%;
        font-size: 14px;
        font-weight: bold;
      }
      .titleR {
        width: 50%;
        text-align: right;
        .titleRText {
          display: inline-block;
          font-size: 14px;
          color: $mainColor;
          margin-left: 40px;
          cursor: pointer;
        }
      }
    }
    .content {
      height: calc(100% - 47px);
      overflow: auto;
      .msg {
        display: flex;
        flex-wrap: wrap;
        padding-top: 10px;
        .msgItem {
          width: 30%;
          display: flex;
          padding: 5px 10px;
          .label {
            font-size: 14px;
            color: $fontColor;
            width: 70px;
            text-align: right;
            line-height: 32px;
            margin-right: 4px;
          }
          .value {
            font-size: 14px;
            color: $fontColor;
            line-height: 32px;
          }
        }
      }
      .relation {
        padding: 10px 0 8px;
        height: calc(100% - 140px);
        box-sizing: border-box;
        .relationTitLine {
          display: flex;
          justify-content: space-between;
          font-size: 14px;
          color: $fontColor;
          padding: 0 18px 10px;
          font-weight: bold;
        }
        .goodsLine {
          background-color: #f3f6ff;
          border: 1px solid #e4e7f8;
          border-radius: 4px;
          .goodsLineTit {
            display: flex;
            justify-content: space-between;
            font-size: 14px;
            color: $fontColor;
            padding: 6px 16px;
            line-height: 32px;
          }
          ::v-deep .el-table tr {
            background-color: #f3f6ff;
            th {
              background-color: #f3f6ff;
              border-top: 1px solid #e0e2f1;
              border-bottom: 1px solid #e0e2f1;
            }
            td {
              border-bottom: 1px solid #e0e2f1;
            }
          }
        }
      }
    }
  }
  .settlement {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 56px;
    background-color: #fff;
    border-radius: 12px 12px 0 0;
    display: flex;
    padding: 12px 20px;
    box-sizing: border-box;
    .settlementL {
      width: 70%;
      font-size: 14px;
      line-height: 32px;
    }
    .settlementR {
      width: 30%;
      text-align: right;
      font-size: 14px;
      line-height: 32px;
      .text {
        color: $fontColor;
        font-size: 14px;
        padding: 0px 24px 0;
        display: inline-block;
        margin-right: 20px;
      }
    }
  }
}
</style>
